
type Props = {
    className?: any,
    name?: any,
    onChange?: any,
    placeHolder?: any,
    value?: any,
    disabled?: boolean,
    maxLength?: any,
    id?: string;
    checked?: any,
    min?: any,
    max?: any,
    onClick?: any,
    onBlur?: any,
    ref?: any,
    defaultValue?: any,
    pattern?: any,
    minLength?: any,
    onLeave?: any,
    title?: any;
    webkitdirectory?: any,
    directory?: any,
    onKeyPress?: any
    cols?: any,
    rows?: any,
    currentLength?: any
};

function WMSTextArea(props: Props) {
    let { className, placeHolder, id, disabled, value, onChange, maxLength, minLength, defaultValue, pattern, onLeave, title, onKeyPress, cols, rows, currentLength } = props;
    return (
        <div className="text-area">
            <textarea autoComplete="off" className={className} placeholder={placeHolder} disabled={disabled} title={title} id={id}
                maxLength={maxLength} minLength={minLength} rows={rows} cols={cols} value={value} onChange={(e) => onChange(e)} onMouseLeave={onLeave}
                onKeyPress={onKeyPress} />
            {/* <p>Text Count: {currentLength === ' ' ? 0 : currentLength} / {maxLength}</p> */}
        </div>
    )
}
export {
    WMSTextArea
};